import React, { Component } from 'react';
import articlesData from '../../data/articlesData.json';

import './ArticlesItems.scss';

class ArticlesItems extends Component {
    componentDidMount() {
        const cards = document.querySelectorAll(".image-container .image");
        const card_boxes = document.querySelectorAll(".item");
        setTimeout(() => {
            cards.forEach(card => {
                // const rect = card.getBoundingClientRect();
                let parent = card.parentNode;
                let parentRect = parent.getBoundingClientRect();
                // log({ rect: { width: rect.width, height: rect.height } });
                card.addEventListener("mousemove", e => {
                    const ax = -(parentRect.width / 2 - e.offsetX) / 15;
                    const ay = (parentRect.height / 2 - e.offsetY) / 20;
                    // log({ ax, ay });
                    parent.style.transform = `rotateY(${ax}deg) rotateX(${ay}deg)`;
                });
                card.addEventListener("mouseleave", e => {
                    parent.style.transform = `rotateY(0deg) rotateX(0deg)`;
                });
            });

            card_boxes.forEach(box => {
                box.addEventListener("mouseenter", e => {
                    box.style.transform = `scale3d(1.05,1.05,1.05)`;
                });
                box.addEventListener("mouseleave", e => {
                    box.style.transform = `scale3d(1,1,1)`;
                });
            });
        }, 500);

    }
    render() {
        const data = articlesData.filter(item => {
            return item.section === this.props.section;
        });
        return (
            <div className={`images-container section${this.props.section}`}>
                {data.map((item, index) => {
                    return (
                        <div key={index} className="item">
                            <div className="image-container" onClick={() => this.props.goToArticle(`${item.article}/${item.comments}`, item.title, this.props.action)}>
                                <div className={`image num${item.item}`}></div>
                                <div className="inner-container">
                                    <div className="inner-title">{item.title}</div>
                                    <div className="inner-desc">{item.desc}</div>
                                    <div className="credit-container">
                                        <div className="credit-wrapper">
                                            {item.isCreditImage ?
                                                <div className={`credit item${item.item}`}></div>
                                                : ""}
                                            <div className="credit-text">{item.creditText}</div>
                                        </div>
                                        <button className="btn-go">{item.btnText}</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    )
                })}
            </div>
        )
    }
}

export default ArticlesItems;



// WEBPACK FOOTER //
// ./src/Components/ArticlesItems/ArticlesItems.jsx